<div class="modal-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Change emergency procedure status</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <a>
        This action will change the current status of the emergency procedure.
        When status is set to active, HaMIS validations will be disabled
        and emergency screens will be activated.<br><br>
        Are you sure you want to continue ?<br><br><br>
      </a>
      <div class="row narrow-gutters always-enabled mb-3 justify-content-center">
        <div class="col-10">

          <div class="row fw-bold pb-2 mb-2">
            <div class="col-6 text-center">
              Port
            </div>
            <div class="col-6 text-center">
              Emergency Procedure status
            </div>
          </div>

          @for (setting of editableEmergencyProcedures; track setting.portUnCode) {
            <div class="row align-items-center mb-2">
              <div class="col-6 text-center">
                {{ setting.portUnCode }}
              </div>
              <div class="col-6 text-center">
                <div class="form-check form-switch d-inline-block">
                  <input
                    class="form-check-input emergency-switch"
                    type="checkbox"
                    [(ngModel)]="setting.enabled"
                    [id]="setting.portUnCode">
                </div>
              </div>
            </div>
          }

          <div class="mt-4 mb-2">
            Type CHANGE to modify Emergency Procedure status
          </div>

          @if (statusMessage) {
            <div
              class="alert mt-2"
              [ngClass]="success ? 'alert-success' : 'alert-danger'">
              {{ statusMessage }}
            </div>
          }

          <input
            type="text"
            class="form-control"
            [(ngModel)]="confirmationText" required>

        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary me-auto" data-bs-dismiss="modal">Cancel
      </button>
      <button type="button" class="btn btn-primary" (click)="saveEmergencyProcedureSettings()">Save Emergency Procedure status
      </button>
      <button #closeButton type="button" hidden data-bs-dismiss="modal"></button>
    </div>
  </div>
</div>

